import type React from 'react';

export interface BondKindBadgeProps {
  kind: string;
  label?: string;
  adversarial?: boolean;
}

export function BondKindBadge({ kind, label, adversarial }: BondKindBadgeProps): React.JSX.Element {
  return (
    <span className={`bond-kind bond-kind--${kind}`} title={kind}>
      {label ?? kind}
      {adversarial === true && (
        <span className="bond-kind__adv-mark" aria-label="Adversarial">
          ⚖
        </span>
      )}
    </span>
  );
}
